import React, { Suspense } from 'react'

import Field from '../../../../components/fields/index'
import { SectionHeader, SubTitle } from '../../../../components/generic'

export default function FamilyLogDetailsSettings(props) {
  const { featureOptionsStyle, formId, homeSettings, isWhiteBackground } = props

  let appImgUrl
  if (homeSettings.familyShowNames) {
    appImgUrl = homeSettings.familyShowDates
      ? isWhiteBackground
        ? TIME_AND_NAMES_WHITE
        : TIME_AND_NAMES
      : isWhiteBackground
        ? NO_TIME_AND_NAMES_WHITE
        : NO_TIME_AND_NAMES
  } else {
    appImgUrl = homeSettings.familyShowDates
      ? isWhiteBackground
        ? TIME_AND_NO_NAMES_WHITE
        : TIME_AND_NO_NAMES
      : isWhiteBackground
        ? NO_TIME_AND_NO_NAMES_WHITE
        : NO_TIME_AND_NO_NAMES
  }

  return (
    <div>
      <div style={styles.sectionContainer}>
        <SectionHeader title={'Log Details'} greyLine compact />
        <div
          style={{ ...styles.featureOptionsContainer, ...featureOptionsStyle }}
        >
          <div style={styles.appPrivacyImg}>
            <img alt="" style={{ width: 224, height: 261 }} src={appImgUrl} />
          </div>
          <div style={{ paddingLeft: 24 }}>
            <SubTitle subTitle={'Time of Log'} />
            <p>
              A specific time will not be shown if you choose to hide the time.
              The timeline of logs will be in the order that they were logged.
            </p>
            <Suspense fallback={<div>Loading...</div>}>
              <Field
                formId={formId}
                keys="familyShowDates"
                layout="no-label"
                displayLabel={false}
                compact
                label="Display carer names"
                type="radios"
                options={PRIVACY_OPTIONS}
                values={homeSettings}
              />
            </Suspense>
            <SubTitle subTitle={'Logged by'} />
            <p>
              If consent has been obtained from staff to share their name, you
              can show the names of the team member that wrote the log to family
              members in the App. This increases your service’s transparency,
              but you need to ensure you have permission from your team.
            </p>
            <Suspense fallback={<div>Loading...</div>}>
              <Field
                formId={formId}
                keys="familyShowNames"
                layout="no-label"
                displayLabel={false}
                compact
                label="Display log times"
                type="radios"
                options={PRIVACY_OPTIONS}
                values={homeSettings}
              />
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  )
}

const TIME_AND_NAMES =
  'https://lmc-data-production.s3.eu-west-2.amazonaws.com/public/timeSHOW_nameSHOW.png'
const TIME_AND_NAMES_WHITE =
  'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/family/timeon_nameon.png'
const TIME_AND_NO_NAMES =
  'https://lmc-data-production.s3.eu-west-2.amazonaws.com/public/timeSHOW_nameHIDE.png'
const TIME_AND_NO_NAMES_WHITE =
  'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/family/timeon_nameoff.png'
const NO_TIME_AND_NAMES =
  'https://lmc-data-production.s3.eu-west-2.amazonaws.com/public/timeHIDE_nameSHOW.png'
const NO_TIME_AND_NAMES_WHITE =
  'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/family/timeoff_nameon.png'
const NO_TIME_AND_NO_NAMES =
  'https://lmc-data-production.s3.eu-west-2.amazonaws.com/public/timeHIDE_nameHIDE.png'
const NO_TIME_AND_NO_NAMES_WHITE =
  'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/family/timeoff_nameoff.png'
const PRIVACY_OPTIONS = [
  { value: true, label: 'Show' },
  { value: false, label: 'Hide' }
]

const styles = {
  appPrivacyImg: {
    paddingTop: 10
  },
  featureOptionsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: 8
  },
  sectionContainer: {
    marginTop: 35,
    marginBottom: 15,
    width: '100%'
  }
}
